<script setup>
import { mdiUpload } from '@mdi/js'
import { computed, ref, watch, onBeforeUnmount, onBeforeMount } from 'vue'
import BaseButton from '@/components/BaseButton.vue'

const props = defineProps({
  modelValue: {
    type: [Object, File, Array],
    default: null
  },
  labelBtn: {
    type: String,
    default: "Выбрать файлы"
  },
  icon : {
    type: String,
    default: mdiUpload
  },
  accept: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: 'info'
  },
  preview: {
    type: Boolean,
    default: false
  },
  multiple: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  maxFiles: {
    type: Number,
    default: 10
  },

})

const emit = defineEmits(['update:modelValue', 'errors'])
const modelValueProp = computed(() => props.modelValue)

watch(modelValueProp, (value) => {
  // completeSelectedFiles.value = value

  if (!value) {
    resetCompleteImages()
  }
})

// const upload = (event) => {
//   const value = event.target.files || event.dataTransfer.files

//   file.value = value[0]

//   emit('update:modelValue', file.value)

  // Use this as an example for handling file uploads
  // let formData = new FormData()
  // formData.append('file', file.value)

  // const mediaStoreRoute = `/your-route/`

  // axios
  //   .post(mediaStoreRoute, formData, {
  //     headers: {
  //       'Content-Type': 'multipart/form-data'
  //     },
  //     onUploadProgress: progressEvent
  //   })
  //   .then(r => {
  //
  //   })
  //   .catch(err => {
  //
  //   })
// }



// const MAX_COMPLETE_FILES = 10

const completeFilesInput = ref(null)
const completeSelectedFiles = ref(props.modelValue) // File[]
const completePreviewUrls = ref([]) // string[]

function revokeCompletePreviewUrls() {
  completePreviewUrls.value.forEach((url) => URL.revokeObjectURL(url))
  completePreviewUrls.value = []
}

function resetCompleteImages() {
  revokeCompletePreviewUrls()
  completeSelectedFiles.value = []
  if (completeFilesInput.value) {
    completeFilesInput.value.value = null
  }
  emit('update:modelValue', completeSelectedFiles.value)
}
function removeCompleteImage(index) {
  emit('errors', {state: false, errorText: ''})

  const urlToRevoke = completePreviewUrls.value[index]
  if (urlToRevoke) URL.revokeObjectURL(urlToRevoke)

  completePreviewUrls.value.splice(index, 1)
  completeSelectedFiles.value.splice(index, 1)
  if (completePreviewUrls.value.length === 0) {
    resetCompleteImages()
  }
}
function onCompleteImagesChange(event) {
  emit('errors', {state: false, errorText: ''})

  const files = Array.from(event.target?.files || [])
  if (!files.length) return

  // Разрешаем добавлять и одно, и несколько фото за раз (без сброса уже выбранных).
  const remaining = props.maxFiles - completeSelectedFiles.value.length
  if (remaining <= 0) {
    emit('errors', {state: true, errorText: `Лимит: максимум ${props.maxFiles} фото`})
    if (completeFilesInput.value) {
      completeFilesInput.value.value = null
    }
    return
  }

  const filesToAdd = files.slice(0, remaining)
  const isOverLimit = files.length > remaining

  filesToAdd.forEach((file) => {
    completeSelectedFiles.value.push(file)
    completePreviewUrls.value.push(URL.createObjectURL(file))
  })

  if (isOverLimit) {
    emit('errors', {state: true, errorText: `Лимит: максимум ${props.maxFiles} фото`})
  }

  // Чтобы можно было повторно выбрать тот же файл.
  if (completeFilesInput.value) {
    completeFilesInput.value.value = null
  }
  emit('update:modelValue', completeSelectedFiles.value)
}
onBeforeMount(() => {
  resetCompleteImages()
})
onBeforeUnmount(() => {
  resetCompleteImages()
})
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between gap-3">
      <span class="text-sm text-gray-500 dark:text-slate-300">
        Подгружено фото: {{ completeSelectedFiles.length }}/{{ maxFiles }}
      </span>
    </div>

    <div class="flex items-stretch justify-start relative">
      <label class="inline-flex">
        <BaseButton
          as="a"
          :icon="icon"
          :label="labelBtn"
          :color="color"
          :disabled="disabled"
          :rounded-full="false"
        />
        <input
          ref="completeFilesInput"
          type="file"
          :accept="accept"
          :multiple="multiple"
          class="absolute top-0 left-0 w-full h-full opacity-0 outline-none cursor-pointer -z-1"
          @change="onCompleteImagesChange"
        />
      </label>
    </div>

    <div
      v-if="completePreviewUrls.length && preview"
      class="grid grid-cols-4 gap-2"
    >
      <div
        v-for="(url, index) in completePreviewUrls"
        :key="url"
        class="relative rounded-lg overflow-hidden"
      >
        <img :src="url" alt="preview" class="w-full h-28 object-cover" />
        <button
          type="button"
          class="absolute top-1 right-1 bg-white/80 dark:bg-slate-800/80
                  text-red-600 dark:text-red-400 rounded-full
                  px-2 py-0.5 text-xs hover:bg-white"
          @click="removeCompleteImage(index)"
        >
          Удалить
        </button>
      </div>
    </div>
  </div>




  <!-- <div class="flex items-stretch justify-start relative">
    <label class="inline-flex">
      <BaseButton
        as="a"
        :class="{ 'w-12 h-12': isRoundIcon, 'rounded-r-none': showFilename }"
        :icon-size="isRoundIcon ? 24 : undefined"
        :label="isRoundIcon ? null : label"
        :icon="icon"
        :color="color"
        :rounded-full="isRoundIcon"
        :disabled="disabled"
      />
      <input
        ref="root"
        type="file"
        class="absolute top-0 left-0 w-full h-full opacity-0 outline-none cursor-pointer -z-1"
        :accept="accept"
        :disabled="disabled"
        @input="upload"
      />
    </label>
    <div
      v-if="showFilename"
      class="px-4 py-2 bg-gray-100 dark:bg-slate-800 border-gray-200 dark:border-slate-700 border rounded-r"
    >
      <span class="text-ellipsis line-clamp-1">
        {{ file.name }}
      </span>
    </div>
  </div> -->
</template>
